import { configureStore } from "@reduxjs/toolkit"

import assignmentSlice from "lib/features/assignment/assignmentSlice"
import courseSlice from "lib/features/course/courseSlice"
import topicSlice from "lib/features/course/topicSlice"
import dsaJudgeSlice from "lib/features/dsaJudge/dsaJudgeSlice"
import dsmlSqlJudgeSlice from "lib/features/dsmlSqlJudge/dsmlSqlJudgeSlice"
import externalReducer from "lib/features/external"
import groqVoiceToTextSlice from "lib/features/groqVoiceToText/groqVoiceToTextSlice"
import hldJudgeSlice from "lib/features/hldJudge/hldJudgeSlice"
import interviewSlice from "lib/features/interview/interviewSlice"
import lldJudgeSlice from "lib/features/lldJudge/lldJudgeSlice"
import sqlJudgeSlice from "lib/features/sqlJudge/sqlJudgeSlice"
import dualCameraSlice from "lib/features/systemCheck/dualCameraSlice"
import systemCheckSlice from "lib/features/systemCheck/systemCheckSlice"
import userSlice from "lib/features/user/userSlice"
import webSocketSlice from "lib/features/webSocket/webSocket"
import webSocketManagerSlice from "lib/features/webSocketManager/webSocketManager"
import headerReducers from "./headerStore"
import languageJudgeReducers from "./language_judge"
import conversationsSlice from "../features/chatbot/conversationsSlice"
import socketSlice from "../features/chatbot/socketSlice"
import enterpriseReducer from "../features/enterprise"
import baseService from "../services/baseService"
import mobilePairingService from "../services/mobilePairingService"

const rootReducer = {
  user: userSlice,
  conversations: conversationsSlice,
  dsaJudge: dsaJudgeSlice,
  dsmlSqlJudge: dsmlSqlJudgeSlice,
  groqVoiceToText: groqVoiceToTextSlice,
  header: headerReducers,
  interview: interviewSlice,
  languageJudge: languageJudgeReducers,
  lldJudge: lldJudgeSlice,
  socket: socketSlice,
  webSocket: webSocketSlice,
  sqlJudge: sqlJudgeSlice,
  systemCheck: systemCheckSlice,
  hldJudge: hldJudgeSlice,
  webSocketManager: webSocketManagerSlice,
  course: courseSlice,
  topic: topicSlice,
  assignment: assignmentSlice,
  enterprise: enterpriseReducer,
  dualCamera: dualCameraSlice,
  external: externalReducer,
  [baseService.reducerPath]: baseService.reducer,
  [mobilePairingService.reducerPath]: mobilePairingService.reducer,
}

export const makeStore = () => {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false }).prepend(
        baseService.middleware,
        mobilePairingService.middleware
      ),
  })
}

export type AppStore = ReturnType<typeof makeStore>
export type RootState = ReturnType<AppStore["getState"]>
export type AppDispatch = AppStore["dispatch"]
